export function findActiveTab(activeTabText) {
  let value;
  switch (activeTabText) {
    case "Description":
      value = "description";
      break;
    case "Beschreibung":
      value = "description";
      break;
    case "Characteristics":
      value = "characteristics";
      break;
    case "Eigenschaften":
      value = "characteristics";
      break;
    default:
      value = "description";
  }
  return value;
}
